import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Table,
  InputGroup,
} from "react-bootstrap";

interface InventoryButtonProps {
  text: String;
  icon: React.ReactNode;
  onClick: () => void;
}

const InventoryButton: React.FC<InventoryButtonProps> = ({
  text,
  icon,
  onClick,
}) => {
  return (
    <Button className="btn_inventory" onClick={onClick}>
      <text className="text_inventory">{text}</text>

      <Row className="align-items-center mb-4 mt-1">
        <Col className="text-center mt-3">{icon}</Col>
      </Row>
    </Button>
  );
};

export default InventoryButton;
